<template>
  <div class="index-box">
    <!-- <div class="infdex-top">
      <div
        :class="index == 1 ? 'index-top-left' : 'index-top-right'"
        @click="character(1)"
      >
        <div>历任领导</div>
        <div class="index-top-left-line"></div>
      </div>
      <div
        :class="index == 2 ? 'index-top-left' : 'index-top-right'"
        @click="character(2)"
      >
        <div>优秀校友</div>
        <div class="index-top-left-line"></div>
      </div>
    </div> -->

    <!-- style="margin-top: 55px" -->
    <div>
      <!-- 历任领导 -->
      <van-list
        v-if="leadershipList != ''"
        class="listBoxVan"
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="listBox">
          <div
            class="RepresentativeListCard"
            v-for="(item, index) in leadershipList"
            :key="index"
            @click="gotoLeadership(item)"
          >
            <div class="card-list__itemone">
              <img class="headDiagram" :src="item.imgPath" />
            </div>
            <div class="card-list__itemtwo">
              <span class="DynamicTitle">{{ item.personName }}</span>
              <span class="DynamicTitle-x">{{ item.post }}</span>
              <span class="DynamicDate ellipsis-multiline">{{
                item.jianjie
              }}</span>
            </div>
          </div>
        </div>
      </van-list>

      <!-- 优秀校友 -->
      <van-list
        v-if="alumniList != ''"
        class="listBoxVan"
        :immediate-check="false"
        v-model="loading"
        :finished="alumnFinished"
        finished-text="没有更多了"
        @load="alumniOnLoad"
      >
        <div class="alumnlistBox">
          <div
            class="RepresentativeListCard"
            v-for="(item, index) in alumniList"
            :key="index"
            @click="gotoAlumni(item)"
          >
            <div class="card-list__itemone">
              <img class="headDiagram" :src="item.imgPath" />
            </div>
            <div class="card-list__itemtwo">
              <span class="DynamicTitle">{{ item.personName }}</span>
              <span class="DynamicTitle-x">{{ item.post }}</span>
              <span class="DynamicDate ellipsis-multiline">{{
                item.jianjie
              }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leadershipList: [],
      alumniList: [],
      index: 2,
      page: 1,
      alumniPage: 1,
      pageSize: 5,
      loading: false,
      finished: false,
      alumnFinished: false,
      lastPage: "",
      alumniLastPage: "",
    };
  },
  created() {
    // this.getLeadership();
    this.getAlumni();
  },
  methods: {
    // 获取历任领导
    async getLeadership() {
      const result = await this.$http.get("/amPerson/getPrincipalByPage", {
        params: { currentPage: this.page, perPage: this.pageSize },
      });
      console.log("获取历任领导", result.data);
      for (let i = 0; i < result.data.list.length; i++) {
        this.leadershipList.push(result.data.list[i]);
      }
      this.lastPage = result.data.lastPage;
    },
    // 获取杰出校友
    async getAlumni() {
      const result = await this.$http.get("/amPerson/getExAlumniByPage", {
        params: { currentPage: this.alumniPage, perPage: this.pageSize },
      });
      console.log("获取杰出校友", result.data);

      for (let i = 0; i < result.data.list.length; i++) {
        this.alumniList.push(result.data.list[i]);
      }
      this.alumniLastPage = result.data.lastPage;

      // this.alumniList = result.data;
    },

    // 历任领导/优秀校友切换
    character(index) {
      this.index = index;
      if (index == 1) {
        this.getLeadership();
        this.alumniList = [];
      } else {
        this.getAlumni();
        this.leadershipList = [];
      }
    },

    // 懒加载
    onLoad() {
      this.alumniPage = 1;
      this.page = this.page + 1;
      this.getLeadership();
      this.alumniList = [];
      // this.getRepresentative();
      this.loading = false;
      // 数据全部加载完成
      if (this.page >= this.lastPage) {
        this.finished = true;
      }
    },

    alumniOnLoad() {
      this.page = 1;
      this.alumniPage = this.alumniPage + 1;
      this.getAlumni();
      this.leadershipList = [];
      this.loading = false;
      // 数据全部加载完成
      if (this.alumniPage >= this.alumniLastPage) {
        this.alumnFinished = true;
      }
    },

    // 历任领导--详情
    gotoLeadership(item) {
      return this.$router.push({
        path: "/characterDetails",
        query: {
          id: item.id,
        },
      });
    },

    // 杰出校友--详情
    gotoAlumni(item) {
      return this.$router.push({
        path: "/CharacterAlumniDetails",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  .infdex-top {
    position: fixed;
    top: 45px;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .index-top-left {
      width: 50vw;
      height: 50px;
      background: #edf6f3;
      color: #067371;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-left-line {
        width: 30px;
        height: 3px;
        background: #067371;
        margin-top: 3px;
      }
    }
    .index-top-right {
      width: 50vw;
      height: 50px;
      background: #edf6f3;
      color: #9e9e9e;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.1rem;
      font-weight: 600;
      .index-top-right-line {
        width: 30px;
        height: 3px;
        background: #9e9e9e;
        opacity: 0;
        margin-top: 3px;
      }
    }
  }

  .listBoxVan {
    position: relative;
    .listBox {
      width: 100vw;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .RepresentativeListCard {
        display: flex;
        width: 95vw;
        background: #fff;
        border-radius: 0.5rem;
        height: 11rem;
        margin-left: 2.5vw;
        margin-top: 10px;
        .card-list__itemone {
          flex: 1;
          width: 30vw;
          margin: 5px 0 5px 5px;
          // margin-left: 5px;
          // border: 1px solid #181616;
          .headDiagram {
            position: relative;
            width: 95%;
            height: 100%;
            z-index: 0;
            border-radius: 10px;
            background-size: 100% 100%;
            image-rendering: -webkit-optimize-contrast;
          }
        }
        .card-list__itemtwo {
          flex: 2;
          margin: 0px 3px 5px 5px;
          display: flex;
          flex-direction: column;
          .DynamicTitle {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1.1rem;
            font-weight: 600;
          }

          .DynamicTitle-x {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1rem;
            color: #727272;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .DynamicDate {
            margin-top: 5px;
            padding-left: 5px;
            font-size: 0.85rem;
            color: #a9a9a9;
            width: 58vw;
            line-height: 20px;
            text-align: justify;
          }
          .ellipsis-multiline {
            line-height: 25px; //行间距
            // text-indent: 4ch;//首行缩进
            text-align: justify; //两端对齐
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .alumnlistBox {
      width: 100vw;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .RepresentativeListCard {
        display: flex;
        width: 95vw;
        background: #fff;
        border-radius: 0.5rem;
        height: 11rem;
        margin-left: 2.5vw;
        margin-top: 10px;
        .card-list__itemone {
          flex: 1;
          width: 30vw;
          margin: 5px 0 5px 5px;
          // margin-left: 5px;
          // border: 1px solid #181616;
          .headDiagram {
            position: relative;
            width: 95%;
            height: 100%;
            z-index: 0;
            border-radius: 10px;
            background-size: 100% 100%;
            image-rendering: -webkit-optimize-contrast;
          }
        }
        .card-list__itemtwo {
          flex: 2;
          margin: 0px 3px 5px 5px;
          display: flex;
          flex-direction: column;
          .DynamicTitle {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1.1rem;
            font-weight: 600;
          }

          .DynamicTitle-x {
            position: relative;
            margin: 5px 5px 0 5px;
            font-size: 1rem;
            color: #727272;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .DynamicDate {
            margin-top: 5px;
            padding-left: 5px;
            font-size: 0.85rem;
            color: #a9a9a9;
            width: 58vw;
            line-height: 20px;
            text-align: justify;
          }
          .ellipsis-multiline {
            line-height: 25px; //行间距
            // text-indent: 4ch;//首行缩进
            text-align: justify; //两端对齐
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Character.vue